import request from '@/utils/request'
 
export function getItem(data) {
  return request({
    url: '/userProfile/Get',
    method: 'post',
    data: { id: data },
  })
}
 
export function fetchList(data) {
  return request({
    url: '/userProfile/List',
    method: 'post',
    data,
  })
}
 

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/userProfile/Create',
    method: 'post',
    data,
  })
}


export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/userProfile/update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/userProfile/Delete',
    method: 'delete',
    data,
  })
}

